//POPUP
const Popup = (function () {

    let activePopup = null;

    function open(id, options = {}) {
        const modal = document.querySelector(`[data-modal="${id}"]`);
        if (!modal) return;

        close();

        activePopup = modal;

        modal.classList.add('is-open');
        document.body.classList.add('modal-open');
        if (window.lenis) {
            window.lenis.stop();
        }
        history.replaceState(null, '', `#${id}`);
    }

    function close() {
        if (!activePopup) return;

        activePopup.classList.remove('is-open');
        document.body.classList.remove('modal-open');

        activePopup = null;
        if (window.lenis) {
            window.lenis.start();
        }
        history.replaceState(null, '', window.location.pathname);
    }

    function bindEvents() {

        // open
        document.addEventListener('click', function (e) {
            const trigger = e.target.closest('.pl');
            if (!trigger) return;

            e.preventDefault();

            const href = trigger.getAttribute('href') || '';
            const id = href.replace('#', '');

            open(id, {
                title: trigger.dataset.title,
                video: trigger.dataset.vid
            });
        });

        // close button
        document.addEventListener('click', function (e) {
            if (e.target.closest('.modal__close')) {
                close();
            }
        });

        // overlay click
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('modal__overlay')) {
                close();
            }
        });

        // ESC
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                close();
            }
        });

        // back button
        window.addEventListener('popstate', function () {
            close();
        });
    }

    return {
        init: bindEvents,
        open,
        close
    };

})();

Popup.init();